import {conditional} from './conditional';

export function hasFeatureValue(featureId, featureValueId, decisions) {
	const key = featureId + '.' + featureValueId;
	return decisions.normalizedDecisions[key] ? decisions.normalizedDecisions[key].isIncluded : false;
}

export function hasNoFeatureValue(featureId, featureValueId, decisions) {
	return !this.hasFeatureValue(featureId, featureValueId, decisions);
}

export function getFeature(variableId, features) {
	return features ? features.find(f => f.variableId === variableId) : null;
}

export function allSatisfied(featureId, decisions) {
	return decisions.isSatisfied;
}

export function isSatisfied(featureId, decisions) {
	return decisions.normalizedFeatures[featureId] ? decisions.normalizedFeatures[featureId].isSatisfied : null;
}

export function isDecided(featureId, decisions) {
	return (featureId in decisions.normalizedFeatures);
}
export function getValueOfFeature(featureId, decisions) {
	// gets first value
	// TODO: handle multiValue Features
	return decisions.normalizedFeatures[featureId] ? decisions.normalizedFeatures[featureId].selectedValues[0] : null;
}
export function getValuesOfFeatureThatCanBeIncluded(featureId, decisions, conditionalVariantValues) {
	// gets all available value
	return Object.entries(decisions.normalizedDecisions)
		.filter(([key, value]) => (key.startsWith(featureId) && value.canBeIncluded))
		.map(([key, v]) => {
			const steps = conditionalVariantValues['EditorialTable.EB_DimmingSteps.1']
				.find(c => c.conditions.includes(v.id));
			if (!steps) {
				return {
					id: v.id,
					value: parseInt(v.id.replace(featureId + '.', ''), 10),
					steps: []
				};
			} else {
				return {
					id: v.id,
					value: parseInt(v.id.replace(featureId + '.', ''), 10),
					steps: steps.value.split(';').map(v2 => parseInt(v2, 10))
				};
			}
		})
		.sort((a, b) => a.value - b.value);
}

// map context attribut to api Context (shorter, and can be changed globally)
const contextMap = {
	SC: 'SystemComponent',
	F: 'Feature',
	'F.S': 'Feature.ShortText',
	'F.L': 'Feature.LongText',
	'F.D': 'Feature.DescriptionUx',
	FV: 'FeatureValue',
	'FV.S': 'FeatureValue.ShortText',
	'FV.L': 'FeatureValue.LongText',
	'FV.D': 'FeatureValue.DescriptionUx',
	D: 'Description',
	'D.S': 'Description.ShortText',
	'D.L': 'Description.LongText',
	'D.D': 'Description.DescriptionUx',
	DV: 'DescriptionValue',
	'DV.S': 'DescriptionValue.ShortText',
	'DV.L': 'DescriptionValue.LongText',
	'DV.D': 'DescriptionValue.DescriptionUx',
};

export function pimText(lang, featureId, context, decisions, translations, valueId = null, prefix = '', suffix = '', defaultString = '') {
	if (decisions.length === 0 || translations.length === 0) return '';

	let lookup = lang + '.' + contextMap[context] + '.' + featureId;
	if (context.startsWith('FV')) {
		if (valueId !== null) {
			lookup += '.' + valueId;
		} else {
			lookup += '.' + getValueOfFeature(featureId, decisions);
		}
	}
	if (translations[lookup] === undefined) {
		return defaultString; // '[' + lookup + ']';
	}
	const translation = translations[lookup];
	return translation ? (prefix + translation.text + suffix) : '';
}

export function pimTextDebug(lang, featureId, context, decisions, translations, valueId = null, prefix = '', suffix = '', defaultString = '') {
	if (decisions.length === 0 || translations.length === 0) return '';

	let lookup = lang + '.' + contextMap[context] + '.' + featureId;
	if (context.startsWith('FV')) {
		if (valueId !== null) {
			lookup += '.' + valueId;
		} else {
			lookup += '.' + getValueOfFeature(featureId, decisions);
		}
	}
	return '[' + lookup + ']';
}

export function hasPimText(lang, featureId, context, decisions, translations, valueId = null, prefix = '', suffix = '') {
	if (decisions.length === 0 || translations.length === 0) return '';

	let lookup = lang + '.' + contextMap[context] + '.' + featureId;
	if (context.startsWith('FV')) {
		if (valueId !== null) {
			lookup += '.' + valueId;
		} else {
			lookup += '.' + getValueOfFeature(featureId, decisions);
		}
	}
	return translations[lookup] !== undefined && translations[lookup] !== '';
}
